import { Editor } from "slate";
import { Transforms } from "slate";
import { useSlateStatic } from "slate-react";
const EditorUtils = Editor;
const useEditor = useSlateStatic;
export {
  Transforms as EditorTransforms,
  EditorUtils,
  useEditor
};
//# sourceMappingURL=slate-reexport.js.map
